module.exports = __webpack_public_path__ + "static/media/Protection.db74e6fb.png";